import { defineMessages } from "react-intl"

export default defineMessages({
  businessInviteCode: {
    defaultMessage: "Business invite code",
    id: "src.components.WebAppPortal.AccountCreation.businessInviteCode",
  },
  businessInviteCodeRequired: {
    defaultMessage: "Business invite code required",
    id:
      "src.components.WebAppPortal.AccountCreation.businessInviteCodeRequired",
  },
  email: {
    defaultMessage: "Email",
    id: "src.components.WebAppPortal.AccountCreation.email",
  },
  emailIsRequired: {
    defaultMessage: "email is required",
    id: "src.components.WebAppPortal.AccountCreation.emailIsRequired",
  },
  firstCheckboxPolicyText: {
    defaultMessage: "Ik ga akkoord met de ",
    id: "src.components.WebAppPortal.AccountCreation.firstCheckboxPolicyText",
  },
  firstName: {
    defaultMessage: "First Name",
    id: "src.components.WebAppPortal.AccountCreation.firstName",
  },
  firstNameNoSpecialChars: {
    defaultMessage: "First name should not contain special characters",
    id: "src.components.WebAppPortal.AccountCreation.firstNameNoSpecialChars",
  },
  iHaveReadAndAcceptThe: {
    defaultMessage: "I have read and accept the: ",
    id: "src.components.WebAppPortal.AccountCreation.iHaveReadAndAcceptThe",
  },
  invalidPhoneNumber: {
    defaultMessage: "Invalid phone number",
    id: "src.components.WebAppPortal.AccountCreation.invalidPhoneNumber",
  },
  lastName: {
    defaultMessage: "Last Name",
    id: "src.components.WebAppPortal.AccountCreation.lastName",
  },
  lastNameNoSpecialChars: {
    defaultMessage: "Last name should not contain special characters",
    id: "src.components.WebAppPortal.AccountCreation.lastNameNoSpecialChars",
  },
  lastNameIsRequired: {
    defaultMessage: "last name is required",
    id: "src.components.WebAppPortal.AccountCreation.lastNameIsRequired",
  },
  mustBeAtMiniumCharacters: {
    defaultMessage: "Must be at least {minChars} characters.",
    id: "src.components.WebAppPortal.AccountCreation.mustBeAtMiniumCharacters",
  },
  nameIsRequired: {
    defaultMessage: "Name is required",
    id: "src.components.WebAppPortal.AccountCreation.nameIsRequired",
  },
  next: {
    defaultMessage: "Next",
    id: "src.components.WebAppPortal.AccountCreation.next",
  },
  password: {
    defaultMessage: "Password",
    id: "src.components.WebAppPortal.AccountCreation.password",
  },
  passwordIsRequired: {
    defaultMessage: "password is required",
    id: "src.components.WebAppPortal.AccountCreation.passwordIsRequired",
  },
  phoneNumber: {
    defaultMessage: "Phone Number",
    id: "src.components.WebAppPortal.AccountCreation.phoneNumber",
  },
  phoneNumberIsRequired: {
    defaultMessage: "phone number is required",
    id: "src.components.WebAppPortal.AccountCreation.phoneNumberIsRequired",
  },
  privacyMessage: {
    defaultMessage:
      "Please let us know how you would like us to treat your data.",
    id: "src.components.WebAppPortal.AccountCreation.privacyMessage",
  },
  privacyTitle: {
    defaultMessage: "Your privacy is important to us.",
    id: "src.components.WebAppPortal.AccountCreation.privacyTitle",
  },
  secondCheckboxPolicyText: {
    defaultMessage:
      "Ik geef toestemming voor de verwerking van mijn locatiegegevens volgens de ",
    id: "src.components.WebAppPortal.AccountCreation.secondCheckboxPolicyText",
  },
  thirdCheckboxPolicyText: {
    defaultMessage: "Ik bevestig dat ik het volgende heb kunnen lezen: ",
    id: "src.components.WebAppPortal.AccountCreation.thirdCheckboxPolicyText",
  },
})
